import { render, staticRenderFns } from "./problemDetail.vue.js?vue&type=template&id=dce403fc&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./problemDetail.vue?vue&type=template&id=dce403fc&scoped=true"
import script from "./problemDetail.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./problemDetail.vue?vue&type=script&lang=js"
export * from "./problemDetail.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./problemDetail.vue?vue&type=script&lang=js"
import style0 from "./problemDetail.vue.scss?vue&type=style&index=0&id=dce403fc&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./problemDetail.vue?vue&type=style&index=0&id=dce403fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce403fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dce403fc')) {
      api.createRecord('dce403fc', component.options)
    } else {
      api.reload('dce403fc', component.options)
    }
    module.hot.accept("./problemDetail.vue.js?vue&type=template&id=dce403fc&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./problemDetail.vue?vue&type=template&id=dce403fc&scoped=true", function () {
      api.rerender('dce403fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/live/Dialog/problemDetail.vue"
export default component.exports